/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-param-reassign */
const React = require('react');
const { useState, useEffect } = require('react');
const classNames = require('classnames');

const { buildUrl, getMinMaxPriceAsString } = require('@pages/V2/utils/clientUtils');
const { FILTERS_IDS } = require('@pages/V2/utils/constants');

const PriceInputsFilter = ({ actualLocation, siteId, filterPosition }) => {
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [maxInput, setMaxInput] = useState('');
  const [minInput, setMinInput] = useState('');
  const buttonClassName = classNames({
    'price-filter__action-link': true,
    active: buttonEnabled,
    disabled: !buttonEnabled,
  });

  const onChangeInput = (e, setInput) => {
    setInput(e.target.value || '');
  };

  useEffect(() => {
    if (minInput !== '' || maxInput !== '') {
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
    }
  }, [minInput, maxInput]);

  const applyFilter = (min = 0, max = 0) => {
    const { price, addQueryParam } = getMinMaxPriceAsString(min, max, siteId);

    const url = buildUrl({
      actualLocation,
      filterId: FILTERS_IDS.PRICE,
      filterValueId: price,
      addQueryParam,
      filterPosition,
    });
    if (typeof document !== 'undefined') document.location.href = url;
  };

  return (
    <div className="price-filter__container">
      <label className="price-filter__label">
        <input
          id="min_input"
          className="price-filter__value"
          placeholder="Mínimo"
          type="number"
          onChange={(e) => {
            onChangeInput(e, setMinInput);
          }}
          value={minInput}
          onKeyUp={() => {}}
        />
      </label>
      <label className="price-filter__label">
        <input
          id="max_input"
          className="price-filter__value"
          placeholder="Máximo"
          type="number"
          onChange={(e) => {
            onChangeInput(e, setMaxInput);
          }}
          value={maxInput}
          onKeyUp={() => {}}
        />
      </label>

      <button
        className={buttonClassName}
        disabled={!buttonEnabled}
        onClick={() => applyFilter(parseInt(minInput, 10) || 0, parseInt(maxInput, 10) || 0)}
      />
    </div>
  );
};

module.exports = PriceInputsFilter;
